"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitializerManager = void 0;
/** @deprecated please use InitializerManagerV2 instead */
class InitializerManager {
    constructor(initializers) {
        this.getNotInitializedKeys = () => {
            return Object.keys(this.initializers).filter(id => {
                return !this.initializers[id].isInitialized;
            });
        };
        this.getInitializersKeysWithResolvedDependencies = (initializersKeys) => {
            return initializersKeys.filter(id => {
                const initializer = this.initializers[id];
                return (!initializer.dependencies.length ||
                    (initializer.dependencies.map(dependency => dependency.isInitialized).every(Boolean) && !initializer.isInitialized));
            });
        };
        this.launchInitializers = () => __awaiter(this, void 0, void 0, function* () {
            const notInitializedKeys = this.getNotInitializedKeys();
            const keysToInitialize = this.getInitializersKeysWithResolvedDependencies(notInitializedKeys);
            yield Promise.all(keysToInitialize.map(id => {
                const initializer = this.initializers[id];
                return Promise.resolve(initializer.launch()).then(initialized => {
                    initializer.setInitialized(initialized);
                });
            }));
            if (this.getNotInitializedKeys().length) {
                yield this.launchInitializers();
            }
            return this.initializers;
        });
        this.initializers = initializers;
    }
}
exports.InitializerManager = InitializerManager;
//# sourceMappingURL=initializer.manager.js.map